import {Component, ViewContainerRef} from '@angular/core';
import * as $ from 'jquery';
import {GlobalState} from './global.state';
import { ToastsManager, ToastOptions } from 'ng2-toastr/ng2-toastr';
import {BaThemePreloader, BaThemeSpinner} from './theme/services';
import {Observable} from "rxjs/Observable";
import {ApplicationAdminServices} from "app/appServices/application";
import {Utility} from "./utilityServices/app.utility";

@Component({
    selector: 'app',
    styleUrls: ['./app.component.scss'],
    template: `
        <div class="connected" *ngIf="!(isConnected | async)">
            <i class="fa fa-ban" style="font-size:24px"></i>
            Check your internet connectiion
        </div>
    <main [ngClass]="{'menu-collapsed': isMenuCollapsed}">
      <div class="additional-bg"></div>
      <router-outlet></router-outlet>
    </main>
  `
})
export class App {

    isMenuCollapsed: boolean = false;
    isConnected: any;
    constructor(private _state: GlobalState,
                private _spinner: BaThemeSpinner,
                private viewContainerRef: ViewContainerRef,
                private userUtility: Utility,
                private appService: ApplicationAdminServices,
                public toastr: ToastsManager, vRef: ViewContainerRef ) {
        this.isConnected = Observable.merge(
            Observable.of(navigator.onLine),
            Observable.fromEvent(window, 'online').map(() => true),
            Observable.fromEvent(window, 'offline').map(() => false));
        this.toastr.setRootViewContainerRef(vRef);
        this.getUserInfo();

        this._loadImages();

        this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
            this.isMenuCollapsed = isCollapsed;
        });
    }

    ngAfterViewInit(): void {
        // hide spinner once all loaders are completed
        BaThemePreloader.load().then((values) => {
            this._spinner.hide();
        });
    }

    getUserInfo() {
        this.appService.getUserDetail().subscribe(
            data => this.loginSuccess(data),
            error => this.loginFail(error),
        );
    }

    loginSuccess(res) {
        // localStorage.setItem(this.userRole, res.data.user_role_id);
        localStorage.setItem('userName', res.data[0].name);
        this.userUtility.userName = res.data[0].name;
        localStorage.setItem('userId', res.data[0].id);
    }

    loginFail(err) {
        if (err.error && err.error.message) {
            this.toastr.error(err.error.message);
        } else {
            this.toastr.error('Server error');
        }
        this._spinner.hide();
    }

    private _loadImages(): void {
        // register some loaders
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts